export default "__VITE_ASSET__DrL8tgnA__"